import {Box, Button, Flex, Grid, Radio, RadioGroup, Stack} from "@chakra-ui/react";
import {useContext} from "react";
import {v4 as uuidv4} from "uuid";
import {AppContext, AppContextI} from "../../../components/context/ContextWrapper";
import {RulesLogic, SpotInfo, TriggerRule, TriggerRules, Zone} from "../../../components/types";
import AmbientZoneRuleDetails from "./AmbientZoneRuleDetails";

type Props = {
    zone: Zone
    allSpotsInfo: SpotInfo[]
}

const AmbientZoneRules = ({zone, allSpotsInfo}: Props) => {
    const appContext: AppContextI = useContext<AppContextI>(AppContext);

    const logicHandler = (val: string) => {
        appContext.updateZone(zone, {
            ...zone,
            triggerRules: {
                logic: val,
                rules: zone.triggerRules?.rules || []
            } as TriggerRules
        } as Zone);
    };

    const addRule = () => {
        const newRules: TriggerRule[] = [
            ...(zone.triggerRules?.rules ? zone.triggerRules.rules : []),
            {
                id: uuidv4(),
                type: "Spot",
                spotId: undefined,
                eventType: "SPOT_TRIGGERED"
            } as TriggerRule
        ];
        appContext.updateZone(zone, {
            ...zone,
            triggerRules: {
                logic: zone.triggerRules?.logic ? zone.triggerRules.logic : "And",
                rules: newRules
            } as TriggerRules
        } as Zone);
    };

    const logicValue = zone.triggerRules?.logic || RulesLogic.AND;

    return (
        <>
            <Box width={"120px"}>
                <Box float={"left"} mr={"2"}>Logic:</Box>
                <RadioGroup value={logicValue} onChange={logicHandler} isDisabled={!appContext.isDraft()}>
                    <Stack direction='row'>
                        <Radio value={RulesLogic.AND.toString()} id={RulesLogic.AND.toString()}>
                            AND
                        </Radio>
                        <Radio value={RulesLogic.OR.toString()} id={RulesLogic.OR.toString()}>
                            OR
                        </Radio>
                    </Stack>
                </RadioGroup>
            </Box>

            <Grid templateColumns={"min-content 1fr min-content"} marginTop={"8px"}>
                <Box/>
                <Flex columnGap={"4px"}>
                    <Button size={"sm"} onClick={addRule} disabled={!appContext.isDraft()}>
                        Add rule
                    </Button>
                </Flex>
            </Grid>
            <Grid gridTemplateColumns={"max-content 1fr 24px"} rowGap={"36px"} marginTop={"8px"}>
                {zone.triggerRules?.rules?.map((rule: TriggerRule) => (
                    <AmbientZoneRuleDetails
                        key={`ambient-zone-rule-${rule.id}`}
                        zone={zone}
                        rule={rule}
                        allSpotsInfo={allSpotsInfo}
                    />
                ))}
            </Grid>
        </>
    );
};

export default AmbientZoneRules;
